import { Clickable, Col, Dropdown, Icon, Input } from 'components';
import { nations } from 'lib';
import { memo, useState } from 'react';
import { TableComponents } from '../../';
import Menu from './Menu';
const AthleteTierItem = memo(({ defaultTier, item, onDeleteTier, handleChange, index, error }) => {
  const disabledBgColor = 'rgba(121, 137, 160, 0.2)';
  const disabledCountry = item.country === 'United States' || defaultTier;
  const [menuVisible, setMenuVisible] = useState(false);
  const sortedNations = nations.sort((a, b) => a.value.localeCompare(b.value));

  return (
    <TableComponents.Tr>
      <TableComponents.Td valign="unset" noBorder>
        {disabledCountry ? (
          <Input wid="140px" disabled defaultValue={item.country} bg={disabledBgColor} />
        ) : (
          <Dropdown
            disabled
            admin
            options={sortedNations}
            selected={item.country}
            handleSelect={(e) => handleChange('country', e.value, index)}
            placeholder="Country..."
            bg="#fff"
            rounded
            wid="100%"
            error={error[index]?.country}
          />
        )}
      </TableComponents.Td>
      <TableComponents.Td valign="unset" noBorder>
        <Input
          wid="140px"
          currency
          align="right"
          step={0.01}
          placeholder={item.currencySymbol}
          prefix={item.currencySymbol}
          value={item.amount}
          onValueChange={(val) => {
            handleChange('amount', val, index);
          }}
          error={error[index]?.amount}
        />
      </TableComponents.Td>
      <TableComponents.Td valign="unset" noBorder>
        <Input
          currency
          wid="80px"
          align="right"
          placeholder="%"
          suffix="%"
          prefix=""
          value={item.serviceFeePct}
          onValueChange={(val) => {
            handleChange('serviceFeePct', val, index);
          }}
          error={error[index]?.serviceFeePct}
        />
      </TableComponents.Td>
      <TableComponents.Td valign="unset" noBorder>
        <Input
          wid="140px"
          currency
          align="right"
          placeholder={item.currencySymbol}
          prefix={item.currencySymbol}
          value={(item.amount * item.serviceFeePct * 0.01).toFixed(2)}
          disabled
          bg={disabledBgColor}
        />
      </TableComponents.Td>
      <TableComponents.Td valign="unset" noBorder>
        <Input
          wid="140px"
          currency
          align="right"
          placeholder={item.currencySymbol}
          prefix={item.currencySymbol}
          value={(item.amount * (100 - item.serviceFeePct) * 0.01).toFixed(2)}
          disabled
          bg={disabledBgColor}
        />
      </TableComponents.Td>
      {!disabledCountry && (
        <TableComponents.Td valign="unset" noBorder>
          <Col float="right" noFlex>
            <Clickable
              onClick={() => {
                setMenuVisible(!menuVisible);
              }}
            >
              <Icon pad="0 24px 0 0" type="menu" dimensions={12} />
            </Clickable>
            <Menu
              dataId={index}
              visible={menuVisible}
              onClick={onDeleteTier}
              close={() => {
                setMenuVisible(false);
              }}
            ></Menu>
          </Col>
        </TableComponents.Td>
      )}
    </TableComponents.Tr>
  );
});

export default AthleteTierItem;
